<template>
<q-list role="list">
  <q-expansion-item 
    class="shadow-1" 
    label="Legend" 
    header-class="text-bold text-body1" 
    dense 
    group="legend" 
    role="listitem" 
    aria-expanded="false"
  >
    <div class="q-pa-sm q-pl-md" v-if="Object.keys(mapStyleInfo).length > 0">
      <div class="text-body2" role="heading" aria-level="3">{{ legendObj.content['title'] }}</div>
      <div v-for="stop in legendObj.content['stops']" class="row q-pb-xs" role="listitem">
        <div class="q-pl-sm" :style="{'background-color': stop[1], 'min-width': '25px'}"></div>
        <div class="q-pl-sm">{{ stop[0] }}</div>
      </div>
      <div class="q-mt-md">Adjust layer transparency</div>
      <q-slider 
        v-model="opacity"                         
        :min="1"  
        :max="100"
        @update:model-value="opacityChange"
        role="slider"
        aria-valuemin="1"
        aria-valuemax="100"
        :aria-valuenow="opacity"
      />
      <div 
        class="sp-spotlight-sel row" 
        v-if="(Object.keys(BIRD_MONTH['1']).includes(mapStyleInfo['attr']) || Object.keys(BIRD_YEAR['1']).includes(mapStyleInfo['attr'])) && route.fullPath != '/spSpotlight'"
        @click="goToSpSpotlight(mapStyleInfo['attr'])"
        role="button"
        tabindex="0"
      >
        <q-icon name="search" size="sm" aria-hidden="true" />Sp Spotlight
      </div>
    </div>
    <div v-else>
      <div class="text-body1 q-pa-sm">Data layers can be displayed in the map by interacting with the content in the left panel.</div>
    </div>
  </q-expansion-item>
  <q-expansion-item 
    class="shadow-1" 
    label="Additional Layers" 
    header-class="text-bold text-body1" 
    dense 
    group="legend" 
    role="listitem" 
    aria-expanded="false"
  >
    <LayerControls @changeLayerVis="addlLayerChange" />
  </q-expansion-item>
  <div v-if="mapNotes.length >0" >
      <div class="text-bold text-body1 q-pl-md q-pt-sm">
          Notes
      </div>
    <div v-for="note in mapNotes" class="q-pl-md q-pr-sm q-pt-sm text-caption">{{ note }}</div>
  </div>
</q-list>

</template>
<script setup>
import { useMapItems } from "../composables/useMapItems"
import LayerControls from "./LayerControls.vue";
import { useRouter, useRoute } from 'vue-router';
import { BIRD_MONTH } from "../assets/SpSpotlightEcoregData.json"
import { BIRD_YEAR } from "../assets/SpSpotlightEcoregData.json"

const router = useRouter();
const route = useRoute();
const {  mapNotes, map, setActiveSpSpotlight, legendObj, mapStyleInfo, activeLayerID,  opacity, setOpacity } = useMapItems()

const opacityChange = () =>{
  setOpacity(opacity.value)
  const o = opacity.value / 100;
  map.value.setPaintProperty(activeLayerID.value, 'fill-opacity', o);
}

const addlLayerChange = (data) =>{
  const layersOn = []
  for (const [name, dObj] of Object.entries(data)) {
    if (dObj.visible){
      layersOn.push(name)
    }
  }
}

const goToSpSpotlight = (sp) =>{
  let s
  // if the sp is being passed from monthgly data, just get the root of the sp
  if (sp.includes("_M")){
    s = sp.slice(0, 4)
  }
  else{
    s = sp
  }
  setActiveSpSpotlight(s)
  router.push('/spSpotlight')
}

</script>
<style>
.sp-spotlight-sel{
  background-color: #1D8177;
  color: white;
  cursor: pointer;
}
</style>